import React from 'react'
import {
  Routes,
  Route,
  BrowserRouter,
  Navigate
} from 'react-router-dom'

import { useUserData } from 'hooks/useUserData'

import Login from 'pages/Common/Login'
import Dashboard from 'pages/Auth/Financial'
import DashboardStudents from 'pages/Auth/Financial/students'
import DashboardCourses from 'pages/Auth/Financial/courses'
import DashboardTeachers from 'pages/Auth/Financial/teachers'
import Teachers from 'pages/Auth/Teachers'
import Students from 'pages/Auth/Students'
import Testimonies from 'pages/Auth/Testimonies'
import Projects from 'pages/Auth/Projects'
import Calendar from 'pages/Auth/Calendar'
import Configs from 'pages/Auth/Configs'
import NotFound from 'pages/Common/NotFound'
import Expense from 'pages/Auth/Financial/expense'
import Courses from 'pages/Auth/Courses'

import AuthLayout from 'layouts/Auth'
import { AuthContextProvider } from 'contexts/auth'

// OACS
import Partners from 'pages/Auth/OACS/partners'
import Links from 'pages/Auth/OACS/links'
import Members from 'pages/Auth/OACS/members'
import Events from 'pages/Auth/OACS/events'

function RequireAuth({ children }: any) {
  const { logged } = useUserData()
  if (!logged) {
    return <Navigate to="/" />
  }

  return children
}

const Router = () => (
  <BrowserRouter>
    <AuthContextProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          element={
            <RequireAuth>
              <AuthLayout />
            </RequireAuth>
          }
        >
          <Route path="/dashboard-students" element={<DashboardStudents />} />
          <Route path="/dashboard-courses" element={<DashboardCourses />} />
          <Route path="/dashboard-teachers" element={<DashboardTeachers />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/expense" element={<Expense />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/students" element={<Students />} />
          <Route path="/testimony" element={<Testimonies />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/configs" element={<Configs />} />

          {/* OACS */}
          <Route path="/oacs/partners" element={<Partners />} />
          <Route path="/oacs/live" element={<Links />} />
          <Route path="/oacs/members" element={<Members />} />
          <Route path="/oacs/events" element={<Events />} />

          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="*" element={<Login />} />
      </Routes>
    </AuthContextProvider>
  </BrowserRouter>
)

export default Router
